import { AccessPointProcessingStep, ImportStepDetailResponse } from "../models";
import { ImportSidePanelTab } from "../state";

export type ImportSidePanelActions =
  { type: ImportSidePanelAction.HideSidePanel } |
  { type: ImportSidePanelAction.GetStepDetail, versionId: number, step: AccessPointProcessingStep, tab: ImportSidePanelTab } |
  { type: ImportSidePanelAction.GetStepDetailFailure, error: string } |
  { type: ImportSidePanelAction.GetStepDetailSuccess, stepDetail: ImportStepDetailResponse } |
  { type: ImportSidePanelAction.SaveSettings } |
  { type: ImportSidePanelAction.SaveSettingsFailure, error: string } |
  { type: ImportSidePanelAction.SaveSettingsSuccess };

export enum ImportSidePanelAction {
  HideSidePanel = "HIDE_SIDE_PANEL",
  GetStepDetail = "GET_STEP_DETAIL",
  GetStepDetailSuccess = "GET_STEP_DETAIL_SUCCESS",
  GetStepDetailFailure = "GET_STEP_DETAIL_FAILURE",
  SaveSettings = "SAVE_SETTINGS",
  SaveSettingsSuccess = "SAVE_SETTINGS_SUCCESS",
  SaveSettingsFailure = "SAVE_SETTINGS_FAILURE",
}
